<template>
  <div class="login">
    <v-card class="mx-auto" max-width="344">
      <v-card-text>
        <v-form ref="form" v-model="valid" @submit="submit" lazy-validation>
          <v-layout wrap>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="user.username"
                  :rules="[rules.required, rules.email]"
                  label="E-Mail Adresse"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  type="password"
                  v-model="user.password"
                  :rules="[rules.required]"
                  label="Passwort"
                   @keyup.enter="submit"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="errorMessage">
              <v-col cols="12">
                 <v-alert type="error">
                  {{ errorMessage }}
                </v-alert>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                 <v-btn
                  :loading="loading"
                  :disabled="loading"
                  color="blue-grey"
                  class="ma-2 white--text"
                  type="submit"
                >
                  <v-icon left dark>mdi-login-variant</v-icon>
                  Einloggen
                </v-btn>
              </v-col>
            </v-row>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import config from '@/config.js';

export default {
  name: 'Login',
  data() {
    return {
      valid: true,
      loading: false,
      errorMessage: '',
      user: {
        username: "",
        password: ""
      },
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      }
    };
  },
  computed: {
    ...mapGetters(['loggedin', 'initialLink'])
  },
  methods: {
    async submit(e) {
      e.preventDefault();

      if (this.$refs.form.validate()) {
        this.loading = true;

        try {
          let res = await this.axios({
            method: 'post',
            url: '/oauth/token',
            data: {
              ...this.user,
              grant_type: 'password',
              client_id: config.client_id,
              client_secret: config.client_secret,
              scope: '*'
            }
          });

          if (res.data.error) {
            this.errorMessage = res.data.msg;
            this.loading = false;
          } else {
            this.$store.commit('setToken', res.data.access_token);

            await this.$store.dispatch('login');

            if (this.loggedin) {
              this.$router.push(this.initialLink);
              this.errorMessage = '';
            } else {
              this.errorMessage = 'Es ist ein Fehler beim Login aufgetreten.';
            }

            this.loading = false;
          }
        } catch (e) {
          console.log(e);
          this.errorMessage = 'Es ist ein Fehler beim Login aufgetreten.';

          this.loading = false;
        }
      }
    }
  }
};
</script>

<style lang="scss">
.login {
  padding-top: 25px;
}
</style>
